<template>
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">

                        <div class="mb-4" v-if="attachment">
                            <div v-if="attachment.mime_type === 'application/pdf'" class="text-center">
                                <a :href="route('attachments.show', attachment)" target='_blank'>
                                    <i class="bi bi-file-earmark-pdf display-1 text-danger"></i>
                                </a>
                            </div>
                            <div v-else>
                                <div class="mb-3 text-center">
                                    <a :href="attachment.large_url" target='_blank'>
                                        <img :src="attachment.thumbnail_url" alt="" class="img-fluid" />
                                    </a>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="thumbnail_url">{{ __('Thumbnail') }}</label>
                                    <input type="text" id="thumbnail_url" class="form-control form-control-sm" :value="attachment.thumbnail_url" onfocus="this.select()">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="large_url">{{ __('Large') }}</label>
                                    <input type="text" id="large_url" class="form-control form-control-sm" :value="attachment.large_url" onfocus="this.select()">
                                </div>
                            </div>
                        </div>

                        <file-input
                            :form="form" 
                            v-model="form.upload_file" 
                            :error="form.errors.upload_file"
                            accept="image/*,application/pdf"
                            v-if="!attachment"
                            />
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Dateiinfo') }}</legend>
                            <text-input label="title" v-model="form.title" :error="form.errors.title" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                            <textarea-input label="description" v-model="form.description" :error="form.errors.description" />
                            <text-input type="url" label="source_url" v-model="form.source_url" :error="form.errors.source_url" :disabled="form.upload_file !== null" />
                            <text-input label="alt_text" v-model="form.alt_text" :error="form.errors.alt_text" />
                            <select-input label="purpose" v-model="form.purpose" :error="form.errors.purpose">
                                <option :value="null">{{ __('Bitte wählen') }}</option>
                                <option :value="k" v-for="(v, k) in purposeOptions">{{ v }}</option>
                            </select-input>
                            <text-input label="copyright" v-model="form.copyright" :error="form.errors.copyright" />
                            <text-input type="number" label="sort_order" v-model="form.sort_order" :error="form.errors.sort_order" />
                        </fieldset>
                    </div>
                </div>
            </div>



            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="attachment">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import FileInput from '@/shared/Inputs/FileInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'attachment',
            'purposeOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            FileInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.attachments.destroy', this.attachment));
            },

        },
    }
</script>
